import React from 'react';
import Modal from './Modal.jsx';

/**
 * Modal for managing movie categories
 * @param {boolean} show - Whether the modal is visible
 * @param {Function} onClose - Function to close the modal
 * @param {Object} movie - Selected movie object
 * @param {Array} categories - List of all categories
 * @param {Function} onToggleCategory - Handler for toggling a category
 * @param {string} newCategoryName - New category name input value
 * @param {Function} onCategoryNameChange - Handler for category name input change
 * @param {Function} onCreateCategory - Handler for creating a new category
 * @param {string} errorMessage - Error message to display (if any)
 */
const AddToCategoryModal = ({
  show,
  onClose,
  movie,
  categories,
  onToggleCategory,
  newCategoryName,
  onCategoryNameChange,
  onCreateCategory,
  errorMessage,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onCreateCategory();
    }
  };

  return (
    <Modal
      show={show}
      onClose={onClose}
      title={`Manage Categories for "${movie?.title}"`}
    >
      <div className="max-h-60 overflow-y-auto pr-2 mb-4">
        {categories.filter((cat) => cat.id !== 'all').length > 0 ? (
          categories
            .filter((cat) => cat.id !== 'all')
            .map((cat) => (
              <label
                key={cat.id}
                className="flex items-center text-white text-lg mb-3 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={movie?.categories?.includes(cat.id) || false}
                  onChange={() => onToggleCategory(cat.id)}
                  className="form-checkbox h-5 w-5 text-[#e50914] mr-3 bg-gray-700 border-gray-600 focus:ring-[#e50914]"
                />
                {cat.name}
              </label>
            ))
        ) : (
          <p className="text-gray-400 text-center">
            No custom categories created yet.
          </p>
        )}
      </div>

      {/* Create New Category Section */}
      <div className="border-t border-gray-600 pt-4">
        <h3 className="text-white text-lg font-semibold mb-3">
          Create New Category
        </h3>
        <div className="flex space-x-2">
          <input
            type="text"
            placeholder="Enter category name..."
            value={newCategoryName}
            onChange={onCategoryNameChange}
            onKeyDown={handleKeyDown}
            className="flex-1 p-3 bg-gray-700 border border-gray-600 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#e50914]"
          />
          <button
            onClick={onCreateCategory}
            className="bg-[#e50914] hover:bg-[#b0060f] text-white font-bold py-3 px-4 transition duration-300 ease-in-out"
          >
            Create
          </button>
        </div>
        {errorMessage && (
          <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
        )}
      </div>
    </Modal>
  );
};

export default AddToCategoryModal;
